export const DraftFeedbackReason = {
    InaccurateContent: 'inaccurateContent',
    WrongTone: 'wrongTone',
    RequiredTooMuchEditing: 'requiredTooMuchEditing',
    TooSlow: 'tooSlow',
    Other: 'other',
} as const;

export type DraftFeedbackReason = (typeof DraftFeedbackReason)[keyof typeof DraftFeedbackReason];

export const DRAFT_FEEDBACK_REASON_KEYS = Object.values(DraftFeedbackReason);
